import CityPageTemplate from "../city-template/CityPageTemplate";
import { stLouisConfig } from "./data";

export default function StLouisPage() {
  return <CityPageTemplate config={stLouisConfig} />;
}